import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const EmailDocIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33559 12.1371L0.427734 10.8371L2.33559 8.92871V12.1371Z"
        fill={currentColor}
      />
      <path
        d="M3.85742 0.872371V13.1747C3.85742 13.1747 10.3249 17.5804 10.3249 17.5805C12.083 18.7698 14.4311 18.7439 16.1663 17.516L22.1397 13.2864V0.872371C22.1397 0.390559 21.7491 0 21.2673 0H4.72979C4.24798 0 3.85742 0.390559 3.85742 0.872371ZM18.9044 11.9915H7.11474C6.70483 11.9915 6.352 11.6766 6.3324 11.2672C6.31148 10.8298 6.65984 10.468 7.0932 10.468H18.8827C19.2927 10.468 19.6457 10.7829 19.6653 11.1924C19.6861 11.6299 19.3373 11.9915 18.9044 11.9915ZM18.9044 7.99449H7.11448C6.70412 7.99449 6.35124 7.67884 6.33235 7.26893C6.31219 6.8315 6.66029 6.47105 7.09325 6.47105H18.8828C19.2928 6.47105 19.6457 6.7859 19.6653 7.19545C19.6861 7.63288 19.3373 7.99449 18.9044 7.99449ZM18.9044 3.99699H7.11474C6.70483 3.99699 6.352 3.68215 6.3324 3.2727C6.31148 2.83527 6.65984 2.47355 7.0932 2.47355H18.883C19.2934 2.47355 19.6464 2.78921 19.6653 3.19922C19.6854 3.6366 19.3368 3.99699 18.9044 3.99699Z"
        fill={currentColor}
      />
      <path
        d="M25.5861 10.8487L23.666 12.2082V8.92871L25.5861 10.8487Z"
        fill={currentColor}
      />
      <path
        d="M26 12.4207V24.8702C26 25.4939 25.4944 25.9996 24.8706 25.9996H1.12937C0.505629 25.9996 0 25.4939 0 24.8702V12.3887L8.23723 18L3.48954 22.7477C3.20095 23.0363 3.1722 23.5058 3.44454 23.8098C3.73694 24.1363 4.24232 24.1496 4.55102 23.8409L9.51945 18.8725C11.8954 20.4269 14.7626 20.2778 16.8792 18.8735L21.8466 23.8409C22.1438 24.138 22.6263 24.1382 22.9237 23.8409C23.2213 23.5433 23.2213 23.0609 22.9237 22.7633L18.1431 17.9833L26 12.4207Z"
        fill={currentColor}
      />
    </svg>
  );
};
